import { Star } from 'lucide-react';

/**
 * Filled/outline star rating. Rounds to the nearest whole star for display,
 * which is what a compact header has room for.
 */
export default function StarRating({ value = 0, max = 5, size = 13, className = '' }) {
  const filled = Math.round(value);

  return (
    <span
      className={`inline-flex items-center gap-0.5 ${className}`}
      title={`${value} out of ${max}`}
    >
      {Array.from({ length: max }, (_, index) => (
        <Star
          key={index}
          size={size}
          aria-hidden="true"
          className={
            index < filled
              ? 'fill-amber-400 text-amber-400'
              : 'fill-transparent text-ink-3/50'
          }
        />
      ))}
      <span className="sr-only">
        {value} out of {max} stars
      </span>
    </span>
  );
}
